module.exports = __webpack_public_path__ + "media/site_templates/www.pavingcontractors.com.au/images/our_services_3-83c29456180c3c967898ebc5d4bd4d25.jpg";